import { useCallback, useEffect } from 'react';
import { equals } from 'utils/array';
import { MarketMoverBatch } from '@stockbitgroup/protos/financial/order_trade/entity/v1/market_mover_pb';
import useDatafeedMessageEffect from '../useDatafeedMessageEffect';
import { MarketMoverWebsocketRequest } from '../../../../@types/movers';
import { useMarketMoverStore } from './marketmover.store';

const useMarketMover = (
  key: string,
  request: MarketMoverWebsocketRequest,
  onMessage: (batch: MarketMoverBatch) => void,
) => {
  const setMoverRequest = useMarketMoverStore((s) => s.setMoverRequest);

  const handleReceiveMessage = useCallback(
    async (message: DatafeedMessageChannel) => {
      const { marketMoverBatch } = message || {};
      if (
        marketMoverBatch &&
        request.moverType === marketMoverBatch.moverType &&
        equals(request.filterStocks, marketMoverBatch.filterStocks)
      ) {
        onMessage(marketMoverBatch);
      }
    },
    [request],
  );

  useEffect(() => {
    setMoverRequest(key, request);

    return () => {
      setMoverRequest(key, undefined);
    };
  }, [key, request, setMoverRequest]);

  useDatafeedMessageEffect('marketMoverBatch', key, handleReceiveMessage);
};

export default useMarketMover;
